module.exports = __webpack_public_path__ + "static/roundtable-b7a0060d64e7bbf584f26ef116af397e.jpeg";